"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _Directions = _interopRequireDefault(require("@material-ui/icons/Directions"));

var _solarReact = require("@solar/solar-react");

var _ProfileItem = _interopRequireDefault(require("../ProfileItem"));

var _UserStatus = _interopRequireDefault(require("../User/UserStatus"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ManufacturerInfo = function ManufacturerInfo(_ref) {
  var manufacturer = _ref.manufacturer,
      onUserClick = _ref.onUserClick,
      onUnitClick = _ref.onUnitClick,
      onStartOnboarding = _ref.onStartOnboarding,
      loading = _ref.loading;
  var primaryContact = manufacturer.primaryContact,
      units = manufacturer.units,
      location = manufacturer.location;
  var onboarded = primaryContact && !!primaryContact.representative;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, primaryContact ? /*#__PURE__*/_react["default"].createElement(_core.List, null, /*#__PURE__*/_react["default"].createElement(_ProfileItem["default"], _extends({
    icon: /*#__PURE__*/_react["default"].createElement(_core.Avatar, {
      src: primaryContact.avatar && primaryContact.avatar.src
    }),
    textLabel: primaryContact.email,
    text: primaryContact.fullName
  }, onboarded ? {
    onClick: function onClick() {
      return onUserClick(primaryContact.representative._id);
    }
  } : {}), !onboarded && !loading && /*#__PURE__*/_react["default"].createElement(_core.Button, {
    disabled: !primaryContact.email,
    variant: "outlined",
    color: "primary",
    onClick: function onClick() {
      return onStartOnboarding(primaryContact._id);
    }
  }, "Uitnodigen"), onboarded && !loading && /*#__PURE__*/_react["default"].createElement(_UserStatus["default"], {
    invitedAt: primaryContact.representative.invitedAt && 'ok',
    activatedAt: primaryContact.representative.activatedAt && 'ok',
    blocked: primaryContact.representative.blocked
  })), /*#__PURE__*/_react["default"].createElement(_ProfileItem["default"], {
    icon: /*#__PURE__*/_react["default"].createElement(_Directions["default"], null),
    textLabel: location.formatted_address,
    text: 'hoofdzetel'
  })) : '', /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, "Vestigingen"), /*#__PURE__*/_react["default"].createElement(_core.List, null, units.map(function (unit) {
    return /*#__PURE__*/_react["default"].createElement(_ProfileItem["default"], {
      icon: /*#__PURE__*/_react["default"].createElement(_Directions["default"], null),
      textLabel: unit.location.formatted_address,
      text: unit.name,
      onClick: function onClick() {
        return onUnitClick(unit._id);
      }
    });
  })));
};

var _default = ManufacturerInfo;
exports["default"] = _default;